"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
// (C) 2020 GoodData Corporation
var Tabs_1 = require("./Tabs");
Object.defineProperty(exports, "Tabs", { enumerable: true, get: function () { return Tabs_1.Tabs; } });
//# sourceMappingURL=index.js.map